module.exports = __webpack_public_path__ + "static/media/1.1.3dca74ad.png";